"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgLabBeakerFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12.982 5h-1.964v4.493c0 .665-.163 1.32-.474 1.905h2.912a4.057 4.057 0 01-.474-1.905V5zM9 3s-1-.037-1 1c0 1 1.053 1 1.053 1v4.493c0 .333-.081.66-.237.953L4.24 18.047C3.53 19.38 4.479 21 5.967 21h12.066c1.488 0 2.436-1.62 1.727-2.953l-4.576-7.601a2.029 2.029 0 01-.237-.953V5S16 5 16 4s-1.053-1-1.053-1H9z' }))); };
exports.default = SvgLabBeakerFilled;
//# sourceMappingURL=LabBeakerFilled.js.map